/// <reference path="../../../../../typings/index.d.ts" />
///<reference path="../../../components/modal/modal.interface.ts"/>
///<reference path="../../../components/models/meevo.model.custom.ts"/>

module Meevo.Plugins.Reports {
   
    class MeevoMatrixComponent implements angular.IComponentController {

        static $inject = [
            '$scope'
        ];
        public sheetBlocks: number[][];

        public mainModel: any;
        public columnNumber: number;
        public rowNumber: number;

        private _startLabelOfTheBeginning: boolean = false;

        set startLabelOfTheBeginning(value: boolean) {
            this._startLabelOfTheBeginning = value;
            if (value) {
                this.mainModel.LabelsStartPosition = 1;
            }
        }

        get startLabelOfTheBeginning() {
            return this._startLabelOfTheBeginning;
        }

        constructor(protected $scope: ng.IScope) {
            this.mainModel.NumberOfLabels = 1;
            this.sheetBlocks = _.range(this.rowNumber).map((num, index) => _.range(index * this.columnNumber + 1, index * this.columnNumber + this.columnNumber+1, 1));
            this.sheetBlocks[0][0] = 1;
        }

        $onInit() {
            this.selectSheetPosition(1);
        }

        selectSheetPosition(position: number) {
            this.mainModel.LabelsStartPosition = position;
            this.startLabelOfTheBeginning = false;
        }

    }

    angular.module('meevo.plugins.reports')
        .component('meevoMatrixComponent', <angular.IComponentOptions>{
            templateUrl: 'app/components/controls/matrix/meevo-matrix.component.html',
            controller: MeevoMatrixComponent,
            controllerAs: '$ctrl',
            bindings: {
                mainModel: '<',
                columnNumber: '<',
                rowNumber: '<'
            }
        });
}
